import { isBlank } from './detailShared'
// ADDENDUM 22 (E28) — cómo se agrupan los componentes montados de una pieza.
//
// ⚠ No faltaba ningún campo: la pantalla pintaba el que no era. `MountedComponentDto` es
// `(code, name, batch, quantity)` desde el principio y Sun rellena `name` con el nombre real; la
// huella digital pintaba `code`, y por eso salían 277 códigos correlativos sin significado.
//
// Medido en factory-lab (aquí no se podía: la población local entera son 10 entradas sobre 6
// piezas): 277 entradas, 42 nombres distintos, 0 sin nombre, 0 con `name` igual al `code`, 0 con
// lote. Los más repetidos, 48 del mismo tornillo y 48 de la misma arandela.
//
// ⚠ LÍMITE DECLARADO de esta solución, no un descuido: se agrupa por NOMBRE porque
// `MountedComponent` no lleva la referencia y añadirla sería trabajo de Sun. Con 0 nombres vacíos y
// 0 iguales al código el nombre agrupa bien EN ESTOS DATOS; si otra instalación tuviera el mismo
// nombre en referencias distintas, se fundirían en una línea. Está dicho en el contrato.
//
// ⚠ Y el recuento es de UNIDADES, no de cantidad consumida. `quantity` existe (es
// `part_workflow_history_raw_material.consumption`, un `Double`) y NO se suma aquí: en la base local
// está a nulo en 9 de 10 filas y en factory-lab no se midió, así que sumarlo sería inventar un
// número. Si allí resulta venir informado, esta decisión hay que volver a mirarla con el dato
// delante.

/**
 * Agrupa los componentes montados por lo que los identifica, conservando sus unidades.
 *
 * ⚠ La clave es el NOMBRE cuando lo hay y el CÓDIGO cuando no, que es la misma regla simétrica del
 * addendum 20 para las operaciones: identifica el que exista. Un componente sin nombre no se mete en
 * un cajón de "sin nombre" junto a otros distintos —eso sería fundir referencias que el dato
 * distingue— ni se descarta, que sería perderlo.
 *
 * El orden de salida es por número de unidades descendente y, a igualdad, alfabético: en una lista
 * de 42 líneas lo que se busca primero es lo que más se repite, y el desempate alfabético hace que
 * dos lecturas seguidas de la misma pieza salgan iguales.
 *
 * @param {Array} components lista tal cual llega de N12 (`part.mountedComponents`)
 * @returns {Array<{key: string, label: string, units: Array, count: number}>}
 */
export const groupMountedComponents = (components) => {
  const source = Array.isArray(components) ? components : []
  const byKey = new Map()

  source.forEach((component) => {
    const item = component || {}
    const name = isBlank(item.name) ? '' : String(item.name)
    const code = isBlank(item.code) ? '' : String(item.code)
    const label = name || code
    // Sin nombre NI código no hay nada con lo que identificarlo ni nada que enseñar al desplegar:
    // se deja fuera en vez de pintar una línea en blanco que nadie puede interpretar.
    if (label === '') return
    if (!byKey.has(label)) byKey.set(label, { key: label, label, units: [] })
    byKey.get(label).units.push(item)
  })

  return Array.from(byKey.values())
    .map((group) => ({ ...group, count: group.units.length }))
    .sort((a, b) => (b.count - a.count) || a.label.localeCompare(b.label))
}
